import ChangePasswordScene from './ChangePasswordScene'
export default ChangePasswordScene